import { isVideoFilename } from '@eigtech/documents-types'
import { ConfirmModal, MenuItem, useDisclosure, useToast } from '@eigtech/ui-shared-dave'
import { useDeleteDocument } from '@eigtech/ui-shared-documents'
import {
  ConvertVideoToMeetingDrawer,
  DocumentActionMenu,
  DocumentColumn,
  UpdateDocumentDrawer,
} from '@eigtech/ui-shared-documents-web'
import { useState } from 'react'

export function EstimatorDocumentActionMenu({ document }: { document: DocumentColumn }) {
  const [isOpenUpdateDocumentDrawer, setIsOpenUpdateDocumentDrawer] = useState(false)

  const confirmModal = useDisclosure()
  const convertVideoModal = useDisclosure()
  const toast = useToast()

  const { mutateAsync: deleteDocument, isPending } = useDeleteDocument()

  async function confirmDeleteDocument() {
    await deleteDocument({ entityId: document.entityId, documentId: document.id })

    toast({
      status: 'success',
      title: 'Successfully deleted document',
    })
  }

  return (
    <>
      <DocumentActionMenu document={document}>
        {document.source === 'Estimator' && (
          <>
            <MenuItem onClick={() => setIsOpenUpdateDocumentDrawer(true)}>Update Document</MenuItem>
            <MenuItem onClick={confirmModal.onOpen}>Delete Document</MenuItem>
          </>
        )}
        {isVideoFilename(document.filename) && (
          <MenuItem onClick={convertVideoModal.onOpen}>Convert to Meeting</MenuItem>
        )}
      </DocumentActionMenu>

      {confirmModal.isOpen && (
        <ConfirmModal
          {...confirmModal}
          confirmLabel="Delete"
          confirmProps={{ colorScheme: 'red' }}
          isPending={isPending}
          title="Delete Document"
          onConfirm={confirmDeleteDocument}
        >
          Are you sure you want to delete this document?
        </ConfirmModal>
      )}
      {convertVideoModal.isOpen && (
        <ConvertVideoToMeetingDrawer {...convertVideoModal} document={document} />
      )}
      {isOpenUpdateDocumentDrawer && (
        <UpdateDocumentDrawer
          document={document}
          open={isOpenUpdateDocumentDrawer}
          onOpenChange={setIsOpenUpdateDocumentDrawer}
        />
      )}
    </>
  )
}
